import React, { Suspense, useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";

import {
  CompanyContext,
  CompanyProvider,
} from "./Portfolio/Components/companyDataContext";
import { UserProvider, useUser } from "./Profile_And_account/Profile/UserProvider";
import FullPageLoader from "./loaders/fullPageLoader";
import ScrollToTop from "./Footer/ScrollToTop";
import lazyWithMinDelay from "./hooks/Lazywithmindelay";
import RequireUserType from "./Products/shared/RequireUserType";
import RouteFallback from "./loaders/RouteFallback";


const AnalyticsLanding = lazyWithMinDelay(
  () => import("./Products/Analytics/AnalyticsLanding"),
);
const DubaiLanding = lazyWithMinDelay(() => import("./Markets/DubaiLanding"));
const InvestorRelation = lazyWithMinDelay(
  () => import("./Products/investor Relation/InvRelation"),
);
const Brokerages = lazyWithMinDelay(() => import("./Products/Brokerage/Brokerages"));
const UserIndividual = lazyWithMinDelay(() => import("./Products/UserIndividual/UserIndividual"))
const USAlanding = lazyWithMinDelay(() => import("./Markets/USAlanding"));
const IndiaLanding = lazyWithMinDelay(() => import("./Markets/IndiaLanding"));
const DubaiExploreMore = lazyWithMinDelay(() => import("./Markets/Dubai/DubaiExploreMore"));

const Solutions = lazyWithMinDelay(() => import("./Solutions/Solutions"));
const RiskmapPage = lazyWithMinDelay(() => import("./pages/RiskmapPage"));
const AccountingNotesPage = lazyWithMinDelay(() => import("./pages/AccountingNotesPage"));

const EquityForm = lazyWithMinDelay(() => import("./EquityAnalysis/EquityFormContainer"));
const ResetPassword = lazyWithMinDelay(() => import("./Login/ResetPassword"));
const Signup = lazyWithMinDelay(() => import("./pages/Signup"));

const EquityVerification = lazyWithMinDelay(
  () => import("./EquityAnalysis/EmailVerification"),
);
const EquityVerificationSuccess = lazyWithMinDelay(
  () => import("./EquityAnalysis/EmailVerificationSuccess"),
);

const Home = lazyWithMinDelay(() => import("./HomePage/Index"), 0);


const Profile = lazyWithMinDelay(() => import("./pages/ProfileAndAcount"));
const ContactUs = lazyWithMinDelay(() => import("./ContactUs/ContactUs"));
const TermsAndConditions = lazyWithMinDelay(
  () => import("./TermsAndConditions/TermsAndConditions"),
);
const PrivacyPolicy = lazyWithMinDelay(() => import("./PrivacyAndPolicy/PrivacyPolicy"));
const Portfolio = lazyWithMinDelay(() => import("./pages/Portfolio"));
const Market = lazyWithMinDelay(() => import("./pages/Market"));
const Watchlist = lazyWithMinDelay(() => import("./pages/Watchlist"));
const Screener = lazyWithMinDelay(() => import("./pages/Screener"));
const Company = lazyWithMinDelay(() => import("./pages/analytics"));
const AiInsightsPage = lazyWithMinDelay(() => import("./pages/Aiinsightspage "));
const AboutUs = lazyWithMinDelay(() => import("./AboutUs/AboutUs"));
const ScreenerLanding = lazyWithMinDelay(() => import("./Products/Screener/ScreenerLanding"));
const PortfolioLanding = lazyWithMinDelay(() => import("./Products/Portfolio/PortfolioLanding"));
const RiskmapLanding = lazyWithMinDelay(() => import("./Products/Riskmap/RiskmapLanding"));
const AccountingNoteLanding = lazyWithMinDelay(() => import("./Products/AccountingNotes/AccountingNotesLanding"));
const BenchmarkLanding = lazyWithMinDelay(() => import("./Products/Benchmarking/BenchmarkLanding"));
const BenchmarkPage = lazyWithMinDelay(() => import("./pages/BenchmarkPage"));
const WatchlistLanding = lazyWithMinDelay(() => import("./Products/Watchlists/WatchlistLanding"));
const PricingLanding = lazyWithMinDelay(() => import("./Pricing/PricingPage"));
const Workspace = lazyWithMinDelay(() => import("./pages/WorkspacePage"));


const INDIVIDUAL_ONLY = ["individual"];
const CORPORATE_ONLY = ["org_corporate"];
const BROKERAGE_ONLY = ["org_brokerage"];

const PortfolioWithContext = () => (
  <CompanyProvider>
    <Portfolio />
  </CompanyProvider>
);

const ScreenerWithContext = () => {
  const { screenerName } = useParams();
  return (
    <CompanyProvider>
      <Screener screenerName={screenerName} />
    </CompanyProvider>
  );
};

const WatchlistWithContext = () => (
  <CompanyProvider>
    <Watchlist />
  </CompanyProvider>
);

const MarketWithContext = () => (
  <CompanyProvider>
    <Market />
  </CompanyProvider>
);

const ScreenerLandingWithContext = () => {
  const { screenerName } = useParams();
  return (
    <CompanyProvider>
      <ScreenerLanding screenerName={screenerName} />
    </CompanyProvider>
  );
};

const PortfolioLandingWithConext = () => (
  <CompanyProvider>
    <PortfolioLanding />
  </CompanyProvider>
);
const WorkspaceWithConext = () => (
  <CompanyProvider>
    <Workspace />
  </CompanyProvider>
);

const PrehideRemover = () => {
  const { accountLoading } = useUser();

  useLayoutEffect(() => {
    if (accountLoading) return; // keep the overlay until the account is known
    document.getElementById("__prehide")?.remove();
    document.documentElement.classList.remove("rf-prehide");
  }, [accountLoading]);

  return null;
};

function App() {
  useLayoutEffect(() => {
    document.getElementById("__prehide")?.remove();
    document.documentElement.classList.remove("rf-prehide");
  }, []);
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <UserProvider>
        <Suspense fallback={<RouteFallback />}>
          <PrehideRemover />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/dubai" element={<DubaiLanding />} />
            <Route exact path="/us" element={<USAlanding />} />
            <Route exact path="/others" element={<IndiaLanding />} />
            {/* <Route
              exact
              path="/corporates"
              element={<InvestorRelation />}
            /> */}
            {/* <Route exact path="/brokerages" element={<Brokerages />} /> */}
            <Route
              exact
              path="/dubai/explore-more"
              element={<DubaiExploreMore />}
            />

            <Route path="/changepassword/" element={<ResetPassword />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/equity-analysis" element={<Solutions />} />
            <Route path="/equity-analysis/sign-up" element={<EquityForm />} />
            <Route path="/thank-you" element={<EquityVerification />} />
            <Route
              path="/verifylink/:id"
              element={<EquityVerificationSuccess />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/macros" element={<MarketWithContext />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/about-company" element={<AboutUs />} />
            <Route path="/pricing" element={<PricingLanding />} />
            {/* <Route
              path="/org/:orgName/workspace/:workspaceName"
              element={<WorkspaceWithConext />}
            /> */}
            {/* <Route path="/individuals" element={<UserIndividual />} /> */}

            <Route element={<RequireUserType allowed={CORPORATE_ONLY} />}>
              <Route exact path="/corporates" element={<InvestorRelation />} />
              <Route
                path="/org/:orgName/workspace/:workspaceName"
                element={<WorkspaceWithConext />}
              />
            </Route>
            <Route element={<RequireUserType allowed={BROKERAGE_ONLY} />}>
              <Route exact path="/brokerages" element={<Brokerages />} />
            </Route>



            <Route element={<RequireUserType allowed={INDIVIDUAL_ONLY} />}>
              <Route path="/analytics" element={<AnalyticsLanding />} />
              <Route
                path="/analytics/:companyname/financial/:financial"
                element={<Company />}
              />
              <Route path="/individuals" element={<UserIndividual />} />

              <Route
                path="/analytics/:companyname/financial/:financial/ai-insights"
                element={<AiInsightsPage />}
              />
              <Route path="/portfolio" element={<PortfolioLandingWithConext />} />
              <Route
                path="/portfolio/:portfolioId"
                element={<PortfolioWithContext />}
              />

              <Route path="/screener" element={<ScreenerLandingWithContext />} />
              <Route
                path="/screener/:screenerName"
                element={<ScreenerWithContext />}
              />

              <Route path="/watchlist" element={<WatchlistLanding />} />
              <Route
                path="/watchlist/my-watchlist"
                element={<WatchlistWithContext />}
              />

              <Route path="/risk-map" element={<RiskmapLanding />} />
              <Route path="/risk-map/:companyname" element={<RiskmapPage />} />

              <Route
                path="/accounting-policies-and-notes"
                element={<AccountingNoteLanding />}
              />
              <Route
                path="/accounting-policies-and-notes/:companyname"
                element={<AccountingNotesPage />}
              />

              <Route path="/benchmark" element={<BenchmarkLanding />} />
              <Route path="/benchmark/:companyname" element={<BenchmarkPage />} />
            </Route>
          </Routes>
        </Suspense>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;